import { Button } from '../components/arc/button/button';
import { Card } from '../components/arc/card/card';
import { ArcPage, ArcPageHeader } from '../components/arc/primitives/arc-primitives';
import './space-dashboard.css';

interface DashboardTile {
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function SpaceDashboard({ eyebrow, description, tiles }: {
  eyebrow: string;
  description: string;
  tiles: DashboardTile[];
}) {
  return (
    <ArcPage className="p1-space-dashboard">
      <ArcPageHeader eyebrow={eyebrow} title="Dashboard" description={description} />
      <div className="p1-space-dashboard-grid">
        {tiles.map((tile) => (
          <Card
            key={tile.title}
            className="p1-space-dashboard-card"
            title={tile.title}
            description={tile.description}
            action={tile.action ? (
              <Button type="button" variant="secondary" size="sm" onClick={tile.action.onClick}>
                {tile.action.label}
              </Button>
            ) : undefined}
          />
        ))}
      </div>
    </ArcPage>
  );
}
